<template>
  <div class="friendship-container">
    <div class="friendship-wrapper flex-row-start-center">
      <div class="friendship-title">友情链接</div>
      <img class="title-icon" src="../../assets/images/jiantou-link.jpg" />
      <div class="flex-row-start-center">
        <div v-for="(item, index) in list" :key="item.linkUrl" class="friendship-item flex-row-start-center">
          <a :href="item.linkUrl" target="_blank">{{ item.linkName }}</a>
          <span v-if="index < list.length - 1">|</span>
        </div>
      </div>
      <a class="more_link" href="javascript:;">更多&gt;&gt;</a>
    </div>
  </div>
</template>
<script>
import { linkList } from '@/api/apis'

export default {
  name: 'Friendship',
  data () {
    return {
      list: []
    }
  },
  created() {
    this.getLinkList()
  },
  methods: {
    getLinkList() {
      linkList().then(res => {
        if(res.code === 200) {
          this.list = res.rows || []
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
.friendship-container {
  margin-top: 20px;
  background: #e4e4e4;
  .friendship-wrapper {
    width: 1005px;
    height: 40px;
    margin: 0 auto;
    .friendship-title {
      color: #000;
    }
    .title-icon {
      width: 25px;
      height: 14px;
      margin-left: 10px;
    }
    .friendship-item {
      margin-left: 20px;
      a {
        text-decoration: none;
        color: #333;
        &:hover {
          color: #fcc200;
        }
      }
      span {
        color: #777777;
        margin: 0 10px;
      }
    }
    .more_link {
      color: #fcc200;
      font-size: 12px;
      font-family: 微软雅黑;
      margin-left: 20px;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
